export const DELIVRY_NOTE_LIST_REQUEST  = 'DELIVRY_NOTE_LIST_REQUEST';
export const DELIVRY_NOTE_LIST_SUCCESS  = 'DELIVRY_NOTE_LIST_SUCCESS';
export const DELIVRY_NOTE_LIST_FAIL     = 'DELIVRY_NOTE_LIST_FAIL';